import React, { useState } from 'react';
import Button from '../ui/Button';

const DeclineEventModal = ({ isOpen, onClose, onConfirm, event, loading = false }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(reason);
    setReason(''); // Reset after submit
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl border border-white/10 shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <form onSubmit={handleSubmit} className="p-4 sm:p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl sm:text-2xl font-bold text-white flex items-center gap-2">
              <span>❌</span>
              Informar Ausência
            </h2>
            <button
              type="button"
              onClick={handleClose}
              className="text-gray-400 hover:text-white hover:bg-white/10 rounded-full w-8 h-8 flex items-center justify-center transition-colors text-2xl"
              disabled={loading}
            >
              ×
            </button>
          </div>

          {/* Event Info */}
          <div className="bg-gradient-to-r from-orange-500/10 to-red-500/10 border border-orange-500/30 rounded-xl p-4 backdrop-blur-sm mb-4">
            <div className="flex items-start space-x-3">
              <span className="text-2xl">⚠️</span>
              <div>
                <h4 className="font-semibold text-white mb-1">
                  {event?.name || 'Evento'}
                </h4>
                <p className="text-sm text-gray-300">
                  Você está informando que não poderá comparecer a este evento.
                </p>
              </div>
            </div>
          </div>

          {/* Reason Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Motivo (opcional)
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Digite o motivo da sua ausência..."
              className="w-full px-4 py-3 bg-slate-700/50 border border-white/20 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none transition-all"
              rows={4}
              maxLength={500}
              disabled={loading}
            />
            <p className="text-xs text-gray-400 mt-1.5">
              {reason.length}/500 caracteres
            </p>
          </div>

          {/* Info Message */}
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-3 backdrop-blur-sm mb-6">
            <p className="text-sm text-blue-300 flex items-start gap-2">
              <span className="text-base">💡</span>
              <span>
                <strong>Dica:</strong> Informar o motivo ajuda a organização do evento e demonstra consideração com o grupo.
              </span>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col-reverse sm:flex-row gap-3 justify-end pt-2">
            <Button
              type="button"
              onClick={handleClose}
              variant="secondary"
              size="md"
              disabled={loading}
              className="w-full sm:w-auto"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="danger"
              size="md"
              loading={loading}
              className="w-full sm:w-auto"
            >
              {loading ? 'Confirmando...' : 'Confirmar Ausência'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeclineEventModal;
